import RxOrderDetail from "./RxOrderDetail";

export default RxOrderDetail;
